import { queryStringify } from '@utils'
import { createRequestHelper } from '@utils/swr'
import { type ECommerceOrderLoginMethodsRequest } from '../types/apiRequest'
import { type OrderLoginMethodsResponse } from '../types/apiResponse'
import { type ECommerceApis } from '../types/apis'

const {
  useRequest,
} = createRequestHelper<ECommerceApis['get']['orderLoginMethods'], OrderLoginMethodsResponse, ECommerceOrderLoginMethodsRequest>({
  client: 'eCommerce',
  key: (params) => {
    if (!params) return null
    const { order_id, project_code, country_code } = params
    if (!order_id) return null
    if (!project_code || !country_code) return null
    return `/orders/${order_id}/login-methods?${queryStringify({ project_code, country_code }, {
      skipEmptyString: true,
      skipNull: true,
    })}`
  },
})

export const useApiOrderLoginMethods = useRequest
